import { lazy } from 'react';
import PageView from './PageView';

const VendorActivationsPage = lazy(() => import('src/pages/vendorActivations'));

export const vendorActivationsRoutes = [
  {
    path: 'vendor-activations',
    element: <PageView permission="BO_CAN_VIEW_PLATFORM_ACTIVATIONS" />,
    children: [{ element: <VendorActivationsPage />, index: true }],
  },
];
